import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { EPaymentMethod, useLandingPageContext } from "pages/Context/LandinPageContext";
import { Button, Card } from "react-bootstrap";
import { generatePaymentToken, IGeneratePaymentToken } from "../service/efi.service";
import { CreatePix, CreateTicket, IPaymentPixResponse, IPaymentTicketLicitem, IPaymentTicketLicitemResponse, PaymentCard } from "../service/payment.service";
import { IPeriodicTime } from "core/enums/plans.enum";
import { FiBox, FiGlobe, FiLayers, FiStar, FiZap } from "react-icons/fi";
import { IconType } from "react-icons";
import IconCreditCard from "components/Icons/IconCreditCard";
import IconPix from "assets/svgs/IconPix";
import IconBarCode from "components/Icons/IconBarCode";
import { hideLoading, showLoading } from "components/LLoading";
import { LTMTransactionStatus } from "core/enums/transaction";
import LAlert from "components/LAlert";
import { monitorTransaction } from "core/functions/monitorTransaction";

export default function CardConfirmPayment() {
  const { selectedPlanContext, paymentMethodContext, supplierDataContext, plansContext, setPixCopyAndPasteContext, timeLeftContext, setTimeLeftContext, setCurrentStepContext, setTicketPDF, pixCopyAndPasteContext, quantityOnDemandContext, setIsManualPaymentContext} = useLandingPageContext();
  const quantityForPlan = selectedPlanContext?.maxOnDemandQuantity === 1 ? 1 : quantityOnDemandContext;

  // Gateway caiu no fluxo manual: avança pro sucesso marcando como manual.
  // A tela final (PaymentWithSuccess) mostra "estamos verificando seu pagamento".
  const handleManualPayment = () => {
    setIsManualPaymentContext(true);
    setCurrentStepContext(4);
  };
  const { values, errors, dirty } = useFormikContext<any>();
  const [, forceUpdate] = useState(false);
  const hasErrors = Object.keys(errors).length > 0;
  const disableButton = !dirty || hasErrors || (paymentMethodContext === EPaymentMethod.PIX && !!pixCopyAndPasteContext);
  const installmentNumber = values?.installmentsNumber ? values?.installmentsNumber : selectedPlanContext?.period.installmentCount;
  const insttallmentValue =selectedPlanContext && (selectedPlanContext?.allAmount/installmentNumber).toFixed(2).replace(".", ",");
  const byInstallments = installmentNumber ?? selectedPlanContext?.period.installmentCount;
  const byInstallmentValue = installmentNumber ? selectedPlanContext && (plansContext[1]?.allAmount*selectedPlanContext?.period?.installmentCount/installmentNumber).toFixed(2).replace(".", ",") : plansContext[1]?.monthlyAmountCurrency;
  const insttallmentValueOnDemand = selectedPlanContext && selectedPlanContext?.period.type === IPeriodicTime.ON_DEMAND ? (selectedPlanContext?.allAmount*quantityForPlan/installmentNumber).toFixed(2).replace(".", ","): null;
  const allAmountCurrencyOnDemand = selectedPlanContext?.period.type === IPeriodicTime.ON_DEMAND ? `R$ ${(selectedPlanContext.allAmount*quantityForPlan).toFixed(2).replace(".", ",")}` : null;


  let data: IPaymentTicketLicitem = {
    planId: selectedPlanContext?._id || "",
    supplierId: supplierDataContext?.idSupplier ?? "",
    installmentsNumber: values.installmentsNumber,
    isCnpjUsed: Boolean(values.identification),
  };


  if(selectedPlanContext?.period.type === IPeriodicTime.ON_DEMAND) {
    data = {...data, onDemandProcessCount: quantityForPlan};
  }

  const FormPayment = {
    [EPaymentMethod.CREDIT_CARD]: <div className="d-flex gap-1 justify-content-center align-items-center fw-bold"  style={{ fontSize: ".875rem"}}>
      <IconCreditCard />
      <p className="m-0">Cartão de Crédito</p>
    </div>,
    [EPaymentMethod.PIX]: <div className="d-flex gap-1 justify-content-center align-items-center fw-bold"  style={{ fontSize: ".875rem"}}>
      <IconPix width={15} className=""/>
      <p className="m-0">Pix</p>
    </div>,
    [EPaymentMethod.BOLETO]: <div className="d-flex gap-1 justify-content-center align-items-center fw-bold"  style={{ fontSize: ".875rem"}}>
      <IconBarCode/>
      <p className="m-0">Boleto</p>
    </div>,
  }[paymentMethodContext];

  const buttonFinishText = {
    [EPaymentMethod.CREDIT_CARD]: "Confirmar e Pagar",
    [EPaymentMethod.PIX]: "Gerar Pix",
    [EPaymentMethod.BOLETO]: "Gerar Boleto",
  }[paymentMethodContext];

  const paymentText = {
    [EPaymentMethod.CREDIT_CARD]: {
      installmentsText: `${byInstallments}x ${byInstallmentValue}/mês`,
      totalAmountText: selectedPlanContext?.allAmountCurrency,
      infoText: "Seu pagamento será processado automaticamente no cartão de crédito.",
    },
    [EPaymentMethod.PIX]: {
      installmentsText: "Pagamento único via Pix",
      totalAmountText: selectedPlanContext?.allAmountCurrency,
      infoText: "Ao gerar o código Pix expira em 5 minutos. Complete o pagamento escaneando o QR Code ou copiando o código.",
    },
    [EPaymentMethod.BOLETO]: {
      installmentsText: `${installmentNumber} boletos de R$ ${insttallmentValue}`,
      totalAmountText: selectedPlanContext?.allAmountCurrency,
      infoText: `Você receberá ${installmentNumber} boletos mensais para pagamento.`,
    }
  }[paymentMethodContext];



  const iconMap: { [key: string]: IconType } = {
    [IPeriodicTime.ON_DEMAND]: FiBox,
    [IPeriodicTime.MONTHLY]: FiStar,
    [IPeriodicTime.QUARTERLY]: FiZap,
    [IPeriodicTime.SEMESTERLY]: FiLayers,
    [IPeriodicTime.YEARLY]: FiGlobe,
  };
  
  const IconComponent = selectedPlanContext && iconMap[selectedPlanContext.period.type];

  useEffect(() => {
    forceUpdate((prev: any) => !prev);
  }, [installmentNumber]); 

  useEffect(() => {
    if (timeLeftContext && timeLeftContext > 0) {
      const regeneratePix = async () => {
        try {
          showLoading();
          const dynamicData: IPaymentTicketLicitem = {
            planId: selectedPlanContext?._id || "",
            supplierId: supplierDataContext?.idSupplier ?? "",
            installmentsNumber: values.installmentsNumber,
            isCnpjUsed: Boolean(values.identification),
            ...(selectedPlanContext?.period.type === IPeriodicTime.ON_DEMAND && {
              onDemandProcessCount: quantityForPlan,
            }),
          };
  
          const response = await CreatePix(dynamicData);
          setPixCopyAndPasteContext(response.pixCopiaECola);
          const dueDate = new Date(response.dueDate.replace(" ", "T")); 
          const now = new Date();
          const newTimeRemaining = Math.max(Math.floor((dueDate.getTime() - now.getTime()) / 1000), 0);
          setTimeLeftContext(newTimeRemaining);
          await monitorTransaction(response._id, true, paymentMethodContext, setCurrentStepContext);
        } catch (err) {
          LAlert({description: `${err}`});
        } finally {
          hideLoading();
        }
      };

      const timer = setInterval(() => {
        setTimeLeftContext((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            regeneratePix();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [timeLeftContext, selectedPlanContext, supplierDataContext, values, quantityOnDemandContext, setTimeLeftContext, setPixCopyAndPasteContext, paymentMethodContext, setCurrentStepContext]);



  const handleSubmitCredtiCard = async () => {
    showLoading();
    setIsManualPaymentContext(false);

    let dataPaymentCard: any = {
      planId: selectedPlanContext?._id || "",
      supplierId: supplierDataContext?.idSupplier ?? "",
      installmentsNumber: Number(values?.installmentsNumber),
      reuseCard: values.reuse,
      customerName: values.holderName,
      customerCpf: values.holderDocument,
      // customerBirth: `${values.expiration.slice(0, 2)}/${values.expiration.slice(3, 7)}`
      paymentToken: "",
      cardMask: "",
    };

    const dataGeneratePaymentToken: IGeneratePaymentToken = {
      ...values,
      expirationMonth: values.expiration.slice(0, 2),
      expirationYear: values.expiration.slice(3, 7)
    };


    if(selectedPlanContext?.period.type === IPeriodicTime.ON_DEMAND) {
      dataPaymentCard = {...dataPaymentCard, onDemandProcessCount: quantityForPlan};
    }
  
    try {
      const token = await generatePaymentToken(dataGeneratePaymentToken);
      const response = await PaymentCard({...dataPaymentCard, paymentToken: token.payment_token, cardMask: token.card_mask});

      if (response?.paymentStatus === LTMTransactionStatus.GATEWAY_FAILED) {
        handleManualPayment();
      } else if (response?.paymentStatus === LTMTransactionStatus.PENDING) {
        await monitorTransaction(response._id, false, paymentMethodContext, setCurrentStepContext, handleManualPayment);
      }
    } catch (err) {
      LAlert({description: `${err}`});
    }  finally {
      hideLoading();
    }
  };


  const handleSubmitPixAndTicket = async () => {
    try {
      showLoading();
      setIsManualPaymentContext(false);
      let response: IPaymentPixResponse | IPaymentTicketLicitemResponse | any;
  
      if (paymentMethodContext === EPaymentMethod.PIX) {
        response = await CreatePix(data);

        if (response?.paymentStatus === LTMTransactionStatus.GATEWAY_FAILED) {
          handleManualPayment();
          return;
        }

        setPixCopyAndPasteContext(response.pixCopiaECola);

        // Converte a dueDate para um objeto Date
        const dueDate = new Date(response.dueDate.replace(" ", "T")); // Garante que seja um formato ISO válido
        const now = new Date();

        // Calcula o tempo restante em segundos
        const timeRemaining = Math.max(Math.floor((dueDate.getTime() - now.getTime()) / 1000), 0);
        setTimeLeftContext(timeRemaining);

        if (response?.paymentStatus === LTMTransactionStatus.PENDING) {
          await monitorTransaction(response._id, true, paymentMethodContext, setCurrentStepContext, handleManualPayment);
        }
      } else {
        response = await CreateTicket(data);

        if (response?.paymentStatus === LTMTransactionStatus.GATEWAY_FAILED) {
          handleManualPayment();
          return;
        }

        setTicketPDF(response?.pdf);
        setCurrentStepContext(4);
        if (response?.pdf) window.open(response.pdf, "_blank");
      }

    } catch (err) {
      LAlert({description: `${err}`});
    } finally {
      hideLoading();
    }
  };

  const handleSubmit = {
    [EPaymentMethod.CREDIT_CARD]: handleSubmitCredtiCard,
    [EPaymentMethod.PIX]: handleSubmitPixAndTicket,
    [EPaymentMethod.BOLETO]: handleSubmitPixAndTicket,
  }[paymentMethodContext];

  return (
    <Card className="mb-6">
      <div className="mx-2 mb-0 p-3 bg-transparent border-bottom">
        <Card.Title className="mb-0">Resumo</Card.Title>
      </div>
      <Card.Body className="d-flex flex-column justify-content-between">
        {selectedPlanContext ? (
          <>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <h5 className="card-title m-0">
                    {IconComponent && (
                      <div className="d-flex gap-2 align-items-center">
                        <div className="bg-white p-2 rounded-full drop-shadow transition-colors duration-300 hover:bg-gray-200">
                          <IconComponent
                            className={"text-blue-600 hover:text-blue-400"}
                          />
                        </div>
                        <h3
                          className={"text-base font-semibold mb-0 text-blue-600"}
                        >
                          {selectedPlanContext.name}
                        </h3>
                      </div>
                  
                    )}
                  </h5>
                </div>
                <div className="mb-1" style={{ fontSize: "1rem"}}>
                  {selectedPlanContext?.discount !== "0" && (
                    <strong className="ms-1 bg-primary text-white px-1" style={{ fontSize: ".75rem"}}>
                      {selectedPlanContext?.discount}
                    </strong>
                  )}
                </div>
              </div>

              <ul className="d-flex flex-column justify-content-start p-0 mb-0  ps-3">
                { !!selectedPlanContext?.benefit && selectedPlanContext?.benefit.map((item, index) => {
                  const isFirstBenefit = index === 0;
                  return (
                    <li key={index} className={`flex items-start text-sm sm:text-base ${isFirstBenefit? "fw-semibold": ""}`} style={{ fontSize: ".875rem"}}>
                      <span
                        className={"mr-2 text-blue-600"}
                      >
                        ✓
                      </span>
                      <p className="m-0 text-start">{item}</p>
                    </li>
                  );
                })}
              </ul>

              <hr className="my-3"/>
              <div className="">
                <h6 className="mb-1 text-gray-600" style={{ fontSize: ".875rem"}}>Método de Pagamento</h6>
                {FormPayment}
              </div>
              <hr className="my-3" />
              <div className="fw-semibold mb-3">

                <div className="card-text d-flex justify-content-between ps-3" style={{ fontSize: ".875rem"}}>
                  <span>{`${installmentNumber}× de R$ ${insttallmentValueOnDemand ?? insttallmentValue}`}</span>
                  <span>{allAmountCurrencyOnDemand ?? selectedPlanContext?.allAmountCurrency}</span>
                </div>
                <div className="text-muted pt-2 fw-regular" style={{ fontSize: ".675rem" }}>
                  {paymentText.infoText}
                </div>
              </div>
              {/* <p className="fs-15">
                  Total: <strong>{selectedPlanContext?.allAmountCurrency}</strong>
              </p> */}



            </div>
            <div className="mt-auto">
              <Button
                variant={disableButton ? "disabled" : "success"}
                className="w-100 button"
                onClick={disableButton ? () => {} : handleSubmit}
                disabled={disableButton} 
              >
                {buttonFinishText}
              </Button>
            </div>
          </>
        ) : (
          <p>Nenhum plano selecionado.</p>
        )}
      </Card.Body>
    </Card>
  );
}